import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { Getrequest } from '../../../../context/AxiosRequest';
import { ContextData } from '../../../../context/Context';
import SoundAlert from '../../../../routes/SoundAlert';
import Badge from '@mui/material/Badge';
import MailIcon from '@mui/icons-material/Mail';
import { Divider } from '@mui/material';



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function NottificationBell() {




  const [open, setOpen] = React.useState(false);
  const [Data,setData] = React.useState([]);
  const {accesstoken,UserTokens} = React.useContext(ContextData)
  const [GlobalLoader,setGlobalLoader] = React.useState(false)

   React.useEffect(()=>{

                async function FetchData() {
                     const response = await Getrequest(`auth/get_upload_doc_applicant/${UserTokens}`,accesstoken)
                    // const response2 = await Getrequest(`auth/get_mssg_notfier/${UserTokens}`,accesstoken)
                      setData(response)

                      
                }

              FetchData()

            



  },[]);


 React.useEffect(() => {
  // Timer 1: every 6 seconds
  const timer1 = setInterval(() => {
    if (open === false) {
      const hasRejected = Data.some(item => item.verify_status === "rejected");
      if (hasRejected) {
        SoundAlert("notification");
      }
    //  setGlobalLoader(prev => !prev);
    }
  }, 8000);

  // Timer 2: every 1 minute
  const timer2 = setInterval(() => {
    if (Data.length > 0) {
      const hasRejected = Data.some(item => item.verify_status === "rejected");
      if (hasRejected) {
        setGlobalLoader(prev => !prev);
         
      }
    }
  }, 5000);

  // Cleanup on unmount
  return () => {
    clearInterval(timer1);
    clearInterval(timer2);
  };
}, [Data]); // optional dependency



  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
     
    setOpen(false);
  };



  return (
    <React.Fragment>
          
    
       <Badge onClick={handleClickOpen} badgeContent={Data.length} color={GlobalLoader ? "info" : "warning"}>
        <MailIcon sx={{fontSize:"3em", color: GlobalLoader ? "red" : "green"}} />
      </Badge>
     
      <Dialog
        open={open}
        slots={{
          transition: Transition,
        }}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      > 
       
        <DialogTitle><span className='font-mono'><MailIcon sx={{fontSize:"2em",color:"green"}} />{"Notifications"}</span></DialogTitle>
        <hr />
          {
            Data.length === 0 &&
            <DialogContentText id="alert-dialog-slide-description" sx={{padding:"1em"}}>
              No notifications available
            </DialogContentText>
          }
        <DialogContent>
            {
           Data && Data.map((item,index)=>
               <div className='relative font-mono' key={index} style={{marginBottom:"1em",padding:"0.5em",backgroundColor:"#f5f5f5",borderRadius:"8px",border:"2.5px solid rgba(6, 3, 54, 0.815)"}}>
                 
                 <div className=' w-full bg-green-950 text-white flex justify-center items-center' style={{display:"flex",gap:"10px",alignItems:"center",marginBottom:"0.5em"}}>
                 <p>  <b className=''> Status:</b> </p>
                  <p className='bg-red-950 p-1'>  {item.verify_status}</p>
                  </div>


                <div style={{display:"flex",gap:"10px",alignItems:"center",marginBottom:"0.5em"}}>
                  <p> <b className=''>Uploaded Document:</b> </p>
                  <p className='text-green-950 '>  {item.document_type_name}</p>
                </div>
              
              {/*  <p>
                {item.document_file_name}
               </p> */}
                <div>
                  
                   <div style={{display:"flex",gap:"10px",alignItems:"center",marginBottom:"0.5em"}}>
                 <p>  <b className=''> Reason:</b> </p>
                  <p className='text-green-950 '>  {item.rejectionReason ?? "No reason provided"}</p>
                  </div>
                <p>
                  <b>Message:</b> <span className='text-green-950 '>{item.reject_message ?? "No message"}</span>
                </p>
                </div>
               
            {/*    <hr /> */}
            </div>
            )
            }
           
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
